import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/codon-usage/pages/CalculatorPage";

export const Route = createFileRoute("/codon-usage")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/codon-usage",
      title: m.codon_meta_title(),
      description: m.codon_meta_description(),
      toolName: m.codon_tool_name(),
      faqs: [
        { q: m.codon_faq_q1(), a: m.codon_faq_a1() },
        { q: m.codon_faq_q2(), a: m.codon_faq_a2() },
        { q: m.codon_faq_q3(), a: m.codon_faq_a3() },
        { q: m.codon_faq_q4(), a: m.codon_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
